import { HowItWorks } from "@/shared/ui/how-it-works"

/** Как устроен бот: сценарий, воронка, блок, публикация. */
export function FunnelsHelp() {
	return (
		<HowItWorks
			id="funnels"
			title="Сценарий и воронки: в чём разница"
			items={[
				{
					term: "Сценарий",
					text: "Всё, что умеет бот: воронки, главное меню, группы и переменные. Один сценарий можно подключить к нескольким ботам, тогда они отвечают одинаково.",
				},
				{
					term: "Воронка",
					text: "Одна цепочка сообщений внутри сценария. Основная запускается, когда человек нажимает «Старт». Воронка «Не понял» отвечает на сообщения, которые бот не распознал. Остальные запускают кнопки, пункты меню, слова, команды и UTM-ссылки.",
				},
				{
					term: "Блок",
					text: "Один шаг воронки: сообщение, вопрос, пауза, условие, оплата. Блоки соединяются стрелками, по ним человек идёт от старта дальше.",
				},
				{
					term: "Публикация",
					text: "Правки сохраняются в черновик сами. Люди увидят их только после кнопки «Опубликовать» вверху страницы.",
				},
			]}
		/>
	)
}

/** Как работает UTM-метка, по шагам. */
export function UtmHelp() {
	return (
		<HowItWorks
			id="utm"
			title="Как работает UTM-метка"
			items={[
				{
					term: "1. Создайте метку",
					text: "Например, insta_bio. Панель соберёт ссылку вида t.me/бот?start=insta_bio, её можно скопировать из таблицы.",
				},
				{
					term: "2. Поставьте ссылку",
					text: "Туда, откуда хотите посчитать людей: в шапку профиля, пост, рекламу, рассылку по почте. Для каждого места лучше своя метка.",
				},
				{
					term: "3. Человек открывает бота",
					text: "Бот запустит выбранную воронку, без неё начнётся основная. Он появится в списке пользователей с этой меткой.",
				},
				{
					term: "4. Смотрите результат",
					text: "В таблице видно, сколько человек пришло по метке и сколько дошло до конца. Клик по названию откроет страницу метки: путь по воронке шаг за шагом и список людей. В «Воронках» и внутри воронки выберите метку в фильтре: цифры на блоках покажут только её людей, а по клику на «Прошли» или «Застряли» откроется список этих людей.",
				},
			]}
			footer="Ссылки с метками уже могут стоять в соцсетях. Если поменять метку, старая ссылка перестанет работать."
		/>
	)
}

/** Что увидит человек при входе и как работает меню. */
export function MainMenuHelp() {
	return (
		<HowItWorks
			id="main-menu"
			title="Что увидит человек"
			items={[
				{
					term: "Приветствие",
					text: "Сообщения после первого входа в бота или после того, как человек дошёл основную воронку до конца.",
				},
				{
					term: "Главное меню",
					text: "Кнопки, по которым человек сам выбирает, что ему нужно: запустить воронку, получить ответ, открыть подменю, сайт или мини-приложение.",
				},
				{
					term: "Клавиатура или кнопки под сообщением",
					text: "Клавиатура всегда на экране вместо обычной. Кнопки под сообщением компактнее: подменю открываются в том же сообщении, а меню приходит после каждой воронки и по команде /menu.",
				},
				{
					term: "Кнопка у поля ввода",
					text: "Может показать список команд или открыть мини-приложение клуба одним нажатием.",
				},
			]}
		/>
	)
}
